import React from 'react';
import { FormControl, FormControlProps } from 'react-bootstrap';

// eslint-disable-next-line react/display-name
const Input: React.FC<FormControlProps> = React.forwardRef((props, ref) => (
  <FormControl {...props} ref={ref} />
));

export default Input;
